import { Role } from './../../shared/models/Com/Role';
import { ReversePipe } from './../../shared/pipes/ReversePipe';
import { GenericVm } from './../../shared/models/system/generic-vm';
import { Globals } from '../../shared/services/globals';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { UserManagerService } from 'src/app/shared/services/user-manager.service';
import { UserNotification } from 'src/app/shared/models/DTO/uer-notification';
import { TopToolbarService } from '../services/top-toolbar.service';
import { UserService } from 'src/app/account/services/user.service';
import { UserRegistration } from 'src/app/shared/models/DTO/UserRegistration';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { registerLocaleData, formatDate } from '@angular/common';
import localAr from '@angular/common/locales/ar-SA';
registerLocaleData(localAr);

@Component({
  selector: 'app-top-toolbar',
  templateUrl: './top-toolbar.component.html',
  styleUrls: ['./top-toolbar.component.css']
})
export class TopToolbarComponent implements OnInit {
  today: number = Date.now();

  todayDate = Date.now();
  nowFormatted: string;

  isLoggedIn$: Observable<boolean>;

  roles;

  selectedRole: string;
  selectedDependant: string;
  empDependants;
  loginUserId: string;
  loginUserName: string;
  loginPatientId: number;
  isEmpolyee: boolean;
  mySubscription: any;
  LoginFullName:string;

  userRoles;
//selectedRole;
userRolesDetails;
selectedRoleDetails;

  constructor(private userManger: UserManagerService, private userService: UserService, public global: Globals,
    public topToolbarService: TopToolbarService, private router: Router , public translate: TranslateService) {
    this.roles = new Array();
    this.roles.push('Admin');
    this.selectedRole = 'Admin' // For demo show
    // this.selectedDependant = this.global.LoginFullName;
   
  }
  getDate() {
    /* alert(formatDate(this.todayDate, 'yyyy', 'en-US'));
     alert(formatDate(this.todayDate, 'yyyy', 'ar-EG'));*/
    
    

    //var transMonth = this.translate.instant('Month.' + nowMon)
    if (this.translate.currentLang == 'en') {
      var nowYear = formatDate(this.todayDate, 'yyyy', 'en-US');
    var nowMon = formatDate(this.todayDate, 'MMM', 'en-US');
    var nowDay = formatDate(this.todayDate, 'd', 'en-US');

     // var currentDate = nowYear + " " + transMonth + " " + nowDay;
     var currentDate = nowYear + " " + nowMon + " " + nowDay;
    }
    else {

      var nowYearAr = formatDate(this.todayDate, 'yyyy', 'ar-SA');
    var nowMonAr = formatDate(this.todayDate, 'MMM', 'ar-SA');
    var nowDayAr = formatDate(this.todayDate, 'd', 'ar-SA');
      
    //  var currentDate = Intl.NumberFormat('ar-SA',{}).format(+nowDay) + " " + transMonth + " " + Intl.NumberFormat('ar-SA',{}).format(+nowYear) ;
    var currentDate = Intl.NumberFormat('ar-SA',{}).format(+nowDayAr) + " " + nowMonAr + " " + Intl.NumberFormat('ar-SA',{}).format(+nowYearAr);
     
    }
    return currentDate.replace('٬','');
  }

  langEn(lang){
    this.global.useLTR(lang);
 
 
 
   }
 
   langAR(lang){
     this.global.userRTL(lang);
 
 
 
   }
  ngOnInit() {
  /*   this.topToolbarService.getNotReadedNotification(this.global.UserId).then(result => {
      this.global.Notifications = (result as GenericVm<UserNotification[]>).data;
    }).catch(res => this.global.spinner = false); */
    this.LoginFullName=this.global.LoginFullName;
    
    if (this.global.UserId != ""){

    this.userService.getById(this.global.UserId).then((result) => {


      this.roles = (result as GenericVm<UserRegistration>).data.roles;

      this.selectedRole = this.roles[0];

      this.global.Role = this.roles[0];

 
      this.isEmpolyee = false;

      if (this.global.Role == 'EmployeePatient') {
        this.isEmpolyee = true;
      }
      else {
        this.isEmpolyee = false;
      }

      this.userRolesDetails=this.global.RolesDetails;
      this.userRoles=this.global.UserData.roleCode;
    //  this.selectedRole=this.global.UserData.roleCode[0];
      this.selectedRoleDetails=this.userRolesDetails[0];

    }).catch(res => this.global.spinner = false);

  }


  }
  UpdateNotificationsToReaded() {
    this.topToolbarService.updateNotificationReaded(this.global.UserId);
    this.global.Notifications.forEach((element) => {
      element.readed = true;
    });
  }
  ChosseRole(role) {
    this.global.Role = role;
    this.selectedRole = role;



  }
  ChooseDependant(dependantUserId, dependantUserName, patientId) {
    this.global.UserId = dependantUserId;
    this.selectedDependant = dependantUserName;

    this.router.navigateByUrl('/auth');
    if (this.router.url == '/auth') {
      this.global.subscribePatientId.next(patientId);
    }

  }

  getNotificationsDesc() {
    return this.global.Notifications.slice().reverse().slice(0, 10);
  }
  getNotReadCount() {
    return this.global.Notifications.filter((obj) => obj.readed === false).length;

  }
  logOut() {
    this.global.Role=null;
    this.userManger.logout();
  }
  ChangeUserRole(role){
    //alert(role);
    this.selectedRole=role.roleCode;
    this.global.Role=role.roleCode;
    this.selectedRoleDetails=role;
    
    if (this.router.url != '/auth') {
      this.router.navigateByUrl('/auth');
    }

   // alert(this.global.Role);
  }

}
